import { createStore } from './store.js';
/**
 * Cross-runtime registry of loaded models. Runtimes register what they load and how to unload it,
 * so an app can show one "loaded models" list and free memory explicitly.
 */
export class ModelRegistry {
    entries = new Map();
    store = createStore([]);
    subscribe = this.store.subscribe;
    list = () => this.store.get();
    get(key) {
        return this.entries.get(key)?.info;
    }
    upsert(info, unload) {
        const prev = this.entries.get(info.key);
        this.entries.set(info.key, { info: { ...prev?.info, ...info }, unload: unload ?? prev?.unload });
        this.emit();
    }
    patch(key, patch) {
        const e = this.entries.get(key);
        if (!e)
            return;
        e.info = { ...e.info, ...patch };
        this.emit();
    }
    /** Remove without calling the unloader (runtime already freed it). */
    remove(key) {
        if (this.entries.delete(key))
            this.emit();
    }
    async unload(key) {
        const e = this.entries.get(key);
        if (!e)
            return;
        this.entries.delete(key);
        this.emit();
        await e.unload?.();
    }
    async unloadAll(runtime) {
        const keys = [...this.entries.values()].filter((e) => !runtime || e.info.runtime === runtime).map((e) => e.info.key);
        await Promise.all(keys.map((k) => this.unload(k)));
    }
    totalBytes() {
        return this.list().reduce((s, m) => s + (m.bytes ?? 0), 0);
    }
    emit() {
        this.store.set([...this.entries.values()].map((e) => e.info));
    }
}
/** Shared default registry used by all @front-brain runtimes unless another one is passed in. */
export const registry = new ModelRegistry();
//# sourceMappingURL=registry.js.map